// extracted by mini-css-extract-plugin
export default {"contentContainer":"OutcomeContent_contentContainer__1waCq","gridLg":"OutcomeContent_gridLg__U8Afy","buttonContainer":"OutcomeContent_buttonContainer__FpV1-"};